import { render } from "./PercepcionComponent.vue?vue&type=template&id=a2c63754&scoped=true"
import script from "./PercepcionComponent.vue?vue&type=script&lang=js"
export * from "./PercepcionComponent.vue?vue&type=script&lang=js"

import "./PercepcionComponent.vue?vue&type=style&index=0&id=a2c63754&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c63754"]])

export default __exports__